export function sanitizeText(text) {
  if (!text) {
    return text;
  }
  return text.replace(/\n/g, ' ');
}